export const PermissionSummaryMockData = [
  {
    id: 'fcbfd7e0-c26d-4850-b258-3f58210e7298',
    name: 'Mock Permission Summary Name',
    description: 'Mock Permission Summary Description',
    selector: 'MockPermissionSelector',
  },
] as any[];
